import { GatewayChargePointModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point.model';
import { HeaderContext } from '@tanstack/react-table';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface ChargePointListCreatedAtHeaderProps
  extends HeaderContext<
    GatewayChargePointModel,
    GatewayChargePointModel['createdAt']
  > {}

export const ChargePointListCreatedAtHeader =
  (): // props: ChargePointListCreatedAtHeaderProps,
  ReactNode => {
    // CONTEXT ///////////////////////////////////////////////////////////////////

    const { t } = useTranslation();

    // RENDER ////////////////////////////////////////////////////////////////////

    return t('delmonicos-shared-sdk.outputs-base-with-timestamp.created-at');
  };
